import { createFileRoute, redirect } from '@tanstack/react-router'
import { AccountingJournalScreen } from '@/features/accounting/journal-screen'
import { hasGrant } from '@/lib/me'

/**
 * The manual journal entry form. It used to sit at the bare `/accounting/
 * journal`, which left the module with no way to browse the entries it had
 * posted; the register took that path and the form moved here, matching
 * `/accounting/invoices/new`.
 */
export const Route = createFileRoute('/_authenticated/accounting/journal/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_journal.create')) {
      throw redirect({ to: '/accounting/journal' })
    }
  },
  component: AccountingJournalScreen,
})
